<template>
  <v-container v-if="this.$vuetify.breakpoint.smAndDown">
    <div class="quick-links">
      <div class="quick-link" v-for="(link, index) in quickLinks" :key="index">
        <v-btn
          :href="link.href"
          class="w-100"
          color="primary py-10"
          x-small
          v-if="link.href"
        >
          <div class="icon">
            <v-img
              v-if="link.icon_type === 'img'"
              :src="link.icon"
              width="24"
              height="24"
              class="filter-white mr-2"
            ></v-img>
            <v-icon class="mr-2" size="24" v-else>{{ link.icon }}</v-icon>
          </div>
          <div>
            {{ link.title }}
          </div>
        </v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  computed: {
    quickLinks() {
      return [
        {
          title: "Emergência",
          icon: "/img/icons/emergency-icon.svg?v=3",
          icon_type: "img",
          href: "tel:+556635172600",
        },
        {
          title: "Ouvidoria",
          icon: "far fa-comment-dots",
          icon_type: "icon",
          href: this.informationsContacts.ombudsman
            ? this.informationsContacts.ombudsman
            : "",
        },
        {
          title: "Trabalhe Conosco",
          icon: "fas fa-user-tie",
          icon_type: "icon",
          href: "https://wa.me/5566999940069",
        },
        {
          title: "Resultado de Exames",
          icon: "fa-stethoscope",
          icon_type: "icon",
          href: "https://exames.hospitaldoispinheiros.com.br:8443/Mediweb/login",
        },
      ];
    },
    informationsContacts() {
      return this.$rest("informations-contacts").item;
    },
  },
  created() {
    this.$rest("informations-contacts").get({
      save: (state, data) => (state.item = data),
    });
  },
};
</script>

<style lang="scss">
.quick-links {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;

  & .w-100 {
    width: 100%;
  }
}

@media (max-width: 300px) {
  .quick-links .v-btn__content {
    flex-direction: column !important;
    flex: auto !important;
  }
}
</style>
